/* ---------------- Styles (minimal) ---------------- */
export const backdropStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

export const modalStyle: React.CSSProperties = {
  background: "var(--m2-wp-conver-content-bg)",
  border: "solid 1px var(--m2-wp-conver-content-border)",
  padding: 16,
  borderRadius: 8,
  width: "100%",
  maxWidth: 768,
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
};

export const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "8px 10px",
  marginTop: 6,
  borderRadius: 6,
  border: "1px solid #ccc",
};
